import React from 'react';
import { cn } from '../../utils/cn';
import { CheckCircle, Clock, AlertCircle, XCircle } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Status Badge component for prop statuses with light/dark mode support
 */
const StatusBadge = ({
  status,
  showIcon = true,
  className,
  children,
  ...rest
}) => {
  const { isDark } = useTheme();
  
  const statusConfig = {
    available: {
      icon: CheckCircle,
      text: 'Available',
      lightClass: 'bg-green-100 text-green-800',
      darkClass: 'bg-green-800 text-green-100'
    },
    checked_out: {
      icon: Clock,
      text: 'Checked Out',
      lightClass: 'bg-orange-100 text-orange-800',
      darkClass: 'bg-orange-800 text-orange-100'
    },
    reserved: {
      icon: AlertCircle,
      text: 'Reserved',
      lightClass: 'bg-purple-100 text-purple-800',
      darkClass: 'bg-purple-800 text-purple-100'
    },
    unavailable: {
      icon: XCircle,
      text: 'Unavailable',
      lightClass: 'bg-red-100 text-red-800',
      darkClass: 'bg-red-800 text-red-100'
    }
  };
  
  const config = statusConfig[status] || statusConfig.unavailable;
  const Icon = config.icon;
  
  const themeClass = isDark ? config.darkClass : config.lightClass;
  
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium',
        themeClass,
        className
      )}
      {...rest}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {children || config.text}
    </span>
  );
};

export default StatusBadge;